import { markdownToHtml } from "./markdownDomain";
import { classNames } from "@/utils/classNames";

export function Markdown({
  value,
  disableLastMargin,
  preview,
  truncate,
  inheritLinkColor,
  undecorated,
  onActionClick,
  enableLinks,
  highlightWords,
}: {
  value: string;
  disableLastMargin?: boolean;
  preview?: boolean;
  truncate?: boolean;
  inheritLinkColor?: boolean;
  undecorated?: boolean;
  onActionClick?: (name: string) => void;
  enableLinks?: boolean;
  highlightWords?: string[];
}) {
  return (
    <div
      className={classNames(
        preview ? "preview-content" : "content",
        disableLastMargin && "disable-last-margin",
        truncate && "truncate",
        inheritLinkColor && "text-inherit",
        undecorated && "undecorated",
      )}
      onClick={(e) => {
        const target = e.target as HTMLElement;
        if (target.tagName === "A" && target.getAttribute("href")?.startsWith("#")) {
          e.preventDefault();
          onActionClick?.(target.getAttribute("href")!);
        }
      }}
    >
      {markdownToHtml(truncate ? value.split("\n")[0] : value, { enableLinks, highlightWords })}
    </div>
  );
}
